/*
 * @Author: gujianghua
 * @Date:   2018-07-21 18:00:58
 * @Last Modified by:   gujianghua
 * @Last Modified time: 2018-08-12 15:00:37
 */
import {
  service
} from '@/utils/request'

export default {
  //分页获取vip套餐列表
  getVipList: (params) => {
    return service({
      url: '/cloud/uac/doctor/vip/getPackagePage',
      method: 'get',
      params: params
    })
  },
  //删除套餐
  delete: (params) => {
    return service({
      url: '/cloud/uac/doctor/vip/deletePackage',
      method: 'post',
      params: params
    })
  },
  //更改vip套餐状态
  changeStatus: (params) => {
    return service({
      url: '/cloud/uac/doctor/vip/updateState',
      method: 'post',
      params: params
    })
  },
  //增加vip
  addVipPackage: (data) => {
    return service({
      url: '/cloud/uac/doctor/vip/addPackage',
      method: 'post',
      data: data
    })
  },
  //修改vip
  editVippackage: (data) => {
    return service({
        url: '/cloud/uac/doctor/vip/updatePackage',
        method: 'post',
        data: data
      })
  },
  //获取套餐详情
  getDatail: (path) => {
    return service({
      url: '/cloud/uac/doctor/vip/getPackage' + path,
      method: 'get',
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/operateManage/vipManage.js